const QuizQuestionActionType = {
  FETCH_ALL_QUIZQUESTION: "FETCH_ALL_QUIZQUESTION",
  FETCH_SINGLE_QUIZQUESTION: "FETCH_SINGLE_QUIZQUESTION",
  ADD_QUIZ_QUESTION: "ADD_QUIZ_QUESTION",
  EDIT_QUIZ_QUESTION: "EDIT_QUIZ_QUESTION",
  DELETE_QUIZ_QUESTION: "DELETE_QUIZ_QUESTION",
};
export default QuizQuestionActionType;
